var animaMic = {

	init : () => {

		const categorias = document.querySelector( 'section#categorias' );
		if( categorias === null ) return true;

		var data = {
			self : categorias,
			microfone : categorias.querySelector( '.microfone' ),
			percurso : 135
		};

		data.self.addEventListener( 
			'mousemove',
			event => { 
				animaMic.parallax( data, event ) 
			}
		);

	},

	parallax( data, event ){

		// Eixo X
		const
			percX = 26,
			moved = ( event.pageX * 100 / window.innerWidth * 2 ),
			limitedX = ( moved > 100 ? 100 : moved ),
			posX = ( percX * ( limitedX / 100 ) )
		;

	    // Eixo Y
	    const 
	    	postTop = event.pageY - data.self.offsetTop,
	    	posY = ( data.self.offsetHeight - postTop * 9 ) / 90;
	    ;

	    // Do move
	    data.microfone.style.transform = `translateX(-${posX}%) translateY(${posY}px)`;
	
	}

}
document.addEventListener( 'DOMContentLoaded', () => {
	animaMic.init();
});